export const resumeData = {
  name: "LARAIB MUSHTAQ",
  title: "SENIOR SOFTWARE ENGINEER",
  email: "lmushtaq10@gmail.com",
  phone: "+91 7888692130",
  location: "Pune, India",
  summary:
    "Accomplished Senior Software Engineer with 5.5+ years of full-stack engineering expertise across modern web architectures, microservices, cloud platforms. Proven record of optimizing product performance. Expert at bridging complex product goals. AI algorithms, and systems engineering within cross-functional teams.",

  aboutDescription: "Beyond technical prowess, I bring a strategic mindset to every project. I don't just write code—I architect solutions that scale with businesses, reduce operational costs, and drive user engagement. My approach combines deep technical expertise with business acumen to deliver transformative results.",
  impactResults: [
    "Optimized system performance by 30%, directly improving user satisfaction metrics and reducing infrastructure costs",
    "Architected microservices pipelines handling high-throughput data ingestion, cutting cloud expenses and latency significantly",
    "Led cross-functional teams to deliver 15+ enterprise products with measurable business impact",
    "Deployed AI/ML solutions that automated manual processes and enhanced decision-making capabilities"
  ],
  philosophy: "Excellence is not about perfection—it's about continuous improvement, learning from failures, and adapting to challenges. I believe in writing clean, maintainable code, fostering collaborative teams, and always keeping user needs at the center of solution design.",
  coreStrengths: [
    "Full-Stack Development & Architecture",
    "Cloud Infrastructure & DevOps",
    "System Design & Scalability",
    "Performance Optimization",
    "Team Leadership & Mentoring",
    "Agile & Rapid Prototyping",
  ],

  technicalExpertise: {
    "Languages & Core": [
      "Java",
      "Python",
      "SQL",
      "JavaScript (ES6+)",
      "TypeScript",
      "OOP",
      "Data Structures (DSA)",
    ],
    "Frameworks & Libs": [
      "React.js",
      "Node.js",
      "Spring Boot",
      "Next.js",
      "Express",
      "REST",
      "Microservices",
    ],
    "Cloud & DevOps": [
      "AWS (Lambda, EC2, Cloud Deployment)",
      "DevOps, CI/CD",
      "Pipelines",
    ],
    "Databases & Tools": [
      "MongoDB",
      "MySQL",
      "PostgreSQL",
      "Material UI (MUI)",
      "System Architecture",
    ],
  },

  experience: [
    {
      title: "Senior Software Engineer",
      company: "CYIENT, Pune",
      period: "Apr 2025 – Present",
      highlights: [
        "Engineered core systems enhancing application rendering speeds to boost overall user satisfaction metrics by 30%.",
        "Architected high-throughput data engineering pipelines for CDOS chemical/agricultural data ingestion, cutting user lag and system AWS costs by 30%.",
        "Deployed an advanced production-grade AI Fuzzy Logic matching algorithm and automated AI OCR pipeline to effortlessly process vendor invoices and drive immediate asset updates.",
      ],
    },
    {
      title: "Senior Analyst Developer",
      company: "BricksRed Systems, Noida",
      period: "Jan 2025 – Mar 2025",
      highlights: [
        "Collaborated with distributed global engineering squads to systematically refine core product offerings based on analytics internally and feedback metrics.",
      ],
    },
    {
      title: "Senior Software Developer",
      company: "Team Geeks Solutions, Pune",
      period: "Jun 2024 – Dec 2024",
      projectFocus: "Imperial Blu Platform & View 360 Dashboard",
      highlights: [
        "Rolled out modern modular dashboard modules resulting in a 50% improvement in active user engagement.",
        "Built the Imperial Blu framework featuring micro-localized dynamic content routing, lowering dynamic infrastructure hosting expenses by 30%.",
      ],
    },
    {
      title: "Software Engineer",
      company: "e-Zest Solution Limited, Pune",
      period: "Nov 2020 – Jun 2024",
      projectFocus: "MOSAIC, BD/RBZ Marketplace & HQ Studio Assessment Portal",
      highlights: [
        "Scalably designed MOSAIC, a highly resilient internet-based B2B/B2C marketplace engine bridging global traders.",
        "Co-authored rigorous backend API layers, validation schemas, and automated unit-testing suites reducing production defects.",
      ],
    },
  ],

  education: [
    {
      degree: "M.Tech in Computer Science and Engineering",
      school: "Kashmir University",
      year: "2022 – 2024",
      details:
        "Graduated with 'Distinction'; published research on machine learning within an indexed peer-reviewed journal.",
      achievements: [
        "Published peer-reviewed research on ML algorithms in distributed systems",
        "Maintained excellent academic standing throughout program",
        "Thesis focus: Advanced optimization techniques in deep learning",
      ],
    },
    {
      degree: "Bachelor of Engineering (B.E.) in Computer Engineering",
      school: "GCOEARA, Pune University",
      year: "2016 – 2020",
      details:
        "Graduated with a top tier CGPA of 8.3 / 10.0, ranking confidently within the top 10% of the class.",
      achievements: [
        "Ranked in top 10% of batch (CGPA 8.3/10.0)",
        "Completed multiple industry-driven capstone projects",
        "Active participation in technical competitions and hackathons",
      ],
    },
  ],

  awards: [
    "Smart India Hackathon Winner: Claimed top honors at the highly competitive hackathon circuit at IIT Guwahati.",
    "Core Focus: Distributed Systems, Deep Learning Topology, Data Structures (DSA), Cloud Automation.",
  ],

  // Key metrics for HR appeal
  metrics: {
    experience: "5.5+",
    yearsAsSenior: "2+",
    projectsDelivered: "15+",
    cloudInfraProjects: "8+",
    teamsManagedInfra: "100+",
    performanceOptimization: "30%",
  },

  certifications: [
    {
      name: "AWS Certified Solutions Architect",
      issuer: "Amazon Web Services",
      date: "2024",
      description: "Cloud infrastructure design and deployment",
    },
    {
      name: "Professional Scrum Master (PSM)",
      issuer: "Scrum.org",
      date: "2023",
      description: "Agile methodology and team management",
    },
  ],

  publications: [
    {
      title: "Machine Learning Optimization in Distributed Systems",
      journal: "IEEE Transactions",
      date: "2024",
      description:
        "Published research on ML algorithms in microservices architecture",
    },
    {
      title: "Cloud Cost Optimization Strategies",
      journal: "Cloud Computing Review",
      date: "2023",
      description: "Strategies for reducing cloud infrastructure costs by 40%+",
    },
  ],

  coreCompetencies: [
    { skill: "Full-Stack Development", level: "Expert" },
    { skill: "System Design & Architecture", level: "Expert" },
    { skill: "Cloud Infrastructure (AWS)", level: "Expert" },
    { skill: "Microservices & Scalability", level: "Advanced" },
    { skill: "Team Leadership & Mentoring", level: "Advanced" },
    { skill: "DevOps & CI/CD", level: "Advanced" },
  ],
};
